import React from 'react';
import styled from 'styled-components';
import { VenueFilterData } from '../../../shared/dto/EntityRepository';
import { UniversalCheckbox } from '../../../shared/component/UniversalCheckbox';
import { useLanguageStore } from '../../../shared/store/languageStore';
import { getVenueFilterLabel } from '../../../shared/util/venueTypeLabel';

interface FilterStationVenueAdmissionProps {
  currentFilter: VenueFilterData;
  setCurrentFilter: (filter: VenueFilterData) => void;
}

const FilterStationVenueAdmission: React.FC<FilterStationVenueAdmissionProps> = ({
  currentFilter,
  setCurrentFilter,
}) => {
  const language = useLanguageStore((s) => s.language);

  return (
    <AdmissionFilterComp>
      <AdmissionSubTitle>
        {getVenueFilterLabel('ADMISSION', language)}
      </AdmissionSubTitle>
      <CheckboxComp>
        <UniversalCheckbox
          checked={currentFilter.admissionFree}
          onChange={() => setCurrentFilter({
            ...currentFilter,
            admissionFree: !currentFilter.admissionFree,
          })}
        />
        {getVenueFilterLabel('FREE_ONLY', language)}
      </CheckboxComp>
    </AdmissionFilterComp>
  );
};

export default FilterStationVenueAdmission;

const AdmissionSubTitle = styled.div`
  margin-bottom: 1.2vh;
  ${({ theme }) => theme.typography.Body_03_1};
`;

const AdmissionFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`;

const CheckboxComp = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 4px;
  user-select: none;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
`;
